import { render, staticRenderFns } from "./FacturaSingle.vue?vue&type=template&id=6d452cc6&scoped=true&lang=pug"
import script from "./FacturaSingle.vue?vue&type=script&lang=js"
export * from "./FacturaSingle.vue?vue&type=script&lang=js"
import style0 from "./FacturaSingle.vue?vue&type=style&index=0&id=6d452cc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d452cc6",
  null
  
)

export default component.exports